<template>
  <v-snackbar
    v-model="snackbar.visible"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    @input="onClose"
    bottom
    right
  >
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="snackbar.hide()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { snackbarService } from '@/services/snackbarService.js';

export default {
  name: 'GlobalSnackbar',
  data() {
    return {
      snackbar: snackbarService
    };
  },
  methods: {
    onClose(visible) {
      if (!visible) {
        this.snackbar.hide();
      }
    }
  }
};
</script> 